<script setup lang="ts">
import LeHeading from "@dsk/components/Heading/LeHeading.vue";
import LeModal from "@dsk/components/LeModal.vue";
import type { ModalProps } from "@dsk/types";
import { useI18n } from "vue-i18n";

import LeDictionaryList from "@/components/dictionaries/LeDictionaryList.vue";
import type { Dictionary, DictionaryListFilter, PrivateProduct } from "@/types";

const props = defineProps<
  ModalProps & {
    product: PrivateProduct;
    dictionaries: Dictionary[];
    filters: DictionaryListFilter[];
  }
>();

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();

const onClose = () => {
  emit("close");
};
</script>

<template>
  <LeModal class="le-subscription-dictionaries-modal" size="xl" :is-open="isOpen" @close="onClose()">
    <template #title>
      <LeHeading size="m" tag="h2">
        {{ t("le-private-subscription-box.dictionary-list-title", { productName: props.product.name }) }}
      </LeHeading>
    </template>

    <template #body>
      <LeDictionaryList
        :dictionaries="props.dictionaries"
        :filters="props.filters"
        show-descriptions-by-default
        show-descriptions-toggle
      />
    </template>
  </LeModal>
</template>
